export const GET_CLIENT_WORKING_TIME_SUCCESS = 'GET_CLIENT_WORKING_TIME_SUCCESS';
export const GET_CLIENT_COMPARE_COMPANIES_SUCCESS = 'GET_CLIENT_COMPARE_COMPANIES_SUCCESS';
